$(function ($) {



/* qwantity start */  

$("button").on("click", function (ev) {
  
           
                var currentQty = $('input[name="quantity"]').val();
                var qtyDirection = $(this).data("direction");
                var newQty = 0;

                if (qtyDirection == "1") {
                    newQty = parseInt(currentQty) + 1;
                } else if (qtyDirection == "-1") {
                    newQty = parseInt(currentQty) - 1;
                }

                // make decrement disabled at 1
                if (newQty == 1) {
                    $(".decrement-quantity").attr("disabled", "disabled");
                
                }

                // remove disabled attribute on subtract
                if (newQty > 1) {
                    $(".decrement-quantity").removeAttr("disabled");
                    // alert("test");
                }

                if (newQty > 0) {
                    newQty = newQty.toString();
                    $('input[name="quantity"]').val(newQty);
                } else {
                    $('input[name="quantity"]').val("1");
                }
            });



/* qwantity end */ 

    /*---------------- Main Slider ------------------*/
    $('.main-slider').slick({
        autoplay: false,
        infinite: false,
        arrows: false,
        dots: true
    });

    /*---------------- best-sellers ------------------*/
    $('.best-sellers-slider').slick({
        dots: false,
        infinite: true,
        speed: 300,
        slidesToShow: 4,
        slidesToScroll: 1,
       adaptiveHeight: true,
        arrows: true,
        responsive: [{
                breakpoint: 1301,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 768,
                settings: {
                    rows: 2,
                    slidesToShow: 2,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 481,
                settings: {
                    rows: 2,
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }

        ]
    });

$(window).load(function() {
    equalheight('.prod-img .prodimg');
  });

  $(window).resize(function() {
    equalheight('.prod-img .prodimg');
  });
 $(window).load(function() {
    equalheight('.product-inner  .product-inner-image');
  });

  $(window).resize(function() {
    equalheight('.product-inner  .product-inner-image');
  }); 
  
  
   
  
    /* best-sellers heightbox */
//     var maxHeight = 0;

//     $(".prod-img .prodimg").each(function () {
//         if ($(this).height() > maxHeight) {
//             maxHeight = $(this).height();
//         }
//     });

//     $(".prod-img .prodimg").height(maxHeight);

    /* best-sellers heightbox end */

 /*---------------- best-sellers Mobile ------------------*/


  if ($(window).width() < 769) { 
    $('.best-sellers-slider-mobile').slick({     
      adaptiveHeight: true,
      infinite: true,     

      arrows: false,
      dots: false,  
      rows: 2, 
      slidesPerRow: 2,
      responsive: [
        {
          breakpoint: 414,
          settings: {
            slidesPerRow: 1        
          }
        }
      ]
    });

  } 
  
  
  
    /*---------------- Responsive Menu ------------------*/
    /*$(".nav-trigger").on('click', function (e) {
        $("body").toggleClass('off-canvas-body');
        $(".menu-bar").toggleClass("off-canvas");
        e.preventDefault();
    });
    if ($(window).width() < 992) {
        $('.menu-bar .menu-toggle > span').on("click", function (e) {
            $(this).parent('.menu-toggle').next('.menu-dropdown').slideToggle(600);
            $(this).toggleClass('ion-ios-arrow-down ion-ios-arrow-up');
            e.stopPropagation();
            e.preventDefault();
        });
    } */





    // $(".nav-trigger2").on('click', function (e) {
    //     $(".sibarbg-cart").toggleClass('off-canvas-body2');
    //     $(".menu-bar2").toggleClass("off-canvas");
    //     e.preventDefault();
    // });
    // if ($(window).width() < 992) {
    //     $('.menu-bar2 .menu-toggle > span').on("click", function (e) {
    //         $(this).parent('.menu-toggle').next('.menu-dropdown').slideToggle(600);
    //         $(this).toggleClass('ion-ios-arrow-down ion-ios-arrow-up');
    //         e.stopPropagation();
    //         e.preventDefault();
    //     });
    // } 


// $(".nav-trigger2").click(function () {
//     $(".header-menu-toggle").toggleClass("menu-open");
// });
// $(".menu-sec a i.icon-close-4").click(function () {
//     $(".header-menu-toggle").removeClass("menu-open");
// });

  
$(".nav-trigger").on('click', function (e) {
        $("body").toggleClass('off-canvas-body');
        $(".menu-bar").toggleClass("off-canvas");
        e.preventDefault();
    });
    if ($(window).width() < 992) {
      $(".site-nav__dropdown").each(function () {
            $(this).slideUp(600);
          });
        $('.site-nav--has-dropdown.dropdown').on("click", "button", function (e) {
          e.stopPropagation();
            e.preventDefault();
          
            $(this).next('.site-nav__dropdown').slideToggle(600);
            //$(this).find('span').toggleClass('new-arrow-up');
            
        });
    }
     


   /* if ($(window).width() > 991) {
        $("li.has-submenu").hover(function () {
            $(this).siblings().removeClass("open");
            $(this).addClass("open");
        });
    }
    if ($(window).width() < 992) {
        if ($('li.has-submenu').hasClass('open')) {
            $('li.has-submenu').removeClass('open');
        }
        $('li.has-submenu > a > span').on("click", function (e) {
            $(this).parent('a').next('.megamenu-submenu').slideToggle(600);
            $(this).toggleClass('ion-ios-plus-empty ion-ios-minus-empty');
            e.stopPropagation();
            e.preventDefault();
        });

    }*/


    /*---------------- Search Popup ------------------*/
    $(".search-toggle").on('click', function (e) {
        $(".serch-popup").slideToggle(600);
        e.preventDefault();
        e.stopPropagation();
    });
    $(".serch-popup").click(function (e) {
        e.stopPropagation();
    });
  
  /*start: product details thumb slider*/
  $('.shop-slider-nav').slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    dots: false,
    arrows: false,
     infinite: true,  
    centerMode: false,
    vertical: true,
    verticalSwiping: true,
    focusOnSelect: true,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
  			vertical: false
        }
      }, 
      {
        breakpoint: 481,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          vertical: false

        }
      },
      {
        breakpoint: 381,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          vertical: false

        }
      }
    ]
  });
  

  $('.shop-slider-nav .slick-current').find('.thumb-container').addClass('custom-border');
  $('.shop-slider-nav').on('afterChange', function(event, slick, currentSlide, nextSlide){
    $(".shop-slider-nav .slick-slide").each(function () {
      $(this).find('.thumb-container').removeClass('custom-border');
    });
    $('.shop-slider-nav .slick-current').find('.thumb-container').addClass('custom-border');
  });
  /*end: product details thumb slider*/
  
    function slickInit() {
                    $(".best-sellers-slider2").slick({
                        dots: false,
                        infinite: true,
                        slidesToShow: 4,
                        slidesToScroll: 1,
                        responsive: [{
                                breakpoint: 1600,
                                settings: {
                                    slidesToShow: 4
                                }
                            },

                            {
                                breakpoint: 1400,
                                settings: {
                                    slidesToShow: 4
                                }
                            },

                            {
                                breakpoint: 1200,
                                settings: {
                                    slidesToShow: 4
                                }
                            },

                            {
                                breakpoint: 940,
                                settings: {
                                    slidesToShow: 3
                                }
                            }, {
                                breakpoint: 767,
                                settings: {
                                    slidesToShow: 3
                                }
                            }, {
                                breakpoint: 568,
                                settings: {
                                    slidesToShow: 2
                                }
                            }
                        ]
                    });
                }
  
  
  
  slickInit();

  $('a[data-toggle="tab"]').on('shown.bs.tab', function (e) {
    $(".best-sellers-slider2").slick("unslick");
    slickInit();
  });
});




/*====================================
=            ON DOM READY            =
====================================*/
$(function() {   
    // Toggle Nav on Click
    $('.toggle-nav').click(function() {
        // Calling a function in case you want to expand upon this.
        toggleNav();
    }); 
  
});


/*========================================
=            CUSTOM FUNCTIONS            =
========================================*/
function toggleNav() {
    if ($('#site-wrapper').hasClass('show-nav')) {
        // Do things on Nav Close
        $('#site-wrapper').removeClass('show-nav');

    } else {
        // Do things on Nav Open
        $('#site-wrapper').addClass('show-nav');
    }

    //$('#site-wrapper').toggleClass('show-nav');
}


$(".nav-trigger2").click(function(){
  $(".bg-overlay").toggleClass("open");
 $(this).animate({scrollTop: 0}, 1000);
 $("html,body").toggleClass("scroll-hidden");   
});

 

$(".close-icon").click(function(){
   $("html,body").removeClass("scroll-hidden"); 
   $(".bg-overlay").removeClass("open");
  
});
  

  
  


    





